import { render, staticRenderFns } from "./thinktank.vue?vue&type=template&id=4e29e7b4&scoped=true"
import script from "./thinktank.vue?vue&type=script&lang=js"
export * from "./thinktank.vue?vue&type=script&lang=js"
import style0 from "./thinktank.vue?vue&type=style&index=0&id=4e29e7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29e7b4",
  null
  
)

export default component.exports